import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'modules/main';

import { isOnlineSelector } from 'modules/metadata';
import { downloadMeteoDataThunk } from 'modules/meteo/redux/thunks';
import { downloadQueueFirstItemSelector } from '../../redux/selectors';

const MeteoDownloader: React.FC = () => {
  const dispatch = useAppDispatch();
  const isOnline = useSelector(isOnlineSelector);
  const downloadItem = useSelector(downloadQueueFirstItemSelector);
  useEffect(() => {
    if (downloadItem && isOnline) {
      dispatch(downloadMeteoDataThunk(downloadItem));
    }
  }, [downloadItem?.link, isOnline]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

export default React.memo(MeteoDownloader);
